module.exports = __webpack_public_path__ + "media/task.c7ca6d96.mp4";